<template>
  <b-overlay :show="busy" rounded="sm">
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="options.icon" class="mr-1"></i>
            <span>{{ options.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body v-if="addRow" class="py-0">
        <b-row class="w-100pct pl-1"> </b-row>
      </b-card-body>
      <b-row v-if="!addRow" class="px-3 mt-3">
        <b-col cols="12" sm="6" md="4">
          <b-card id="cursnapshot" :no-body="true">
            <b-card-body class="p-0 clearfix">
              <i
                class="fa fa-camera bg-secondary p-4 font-2xl mr-3 float-left"
              ></i>
              <div class="h5 text-primary mb-0 pt-3">
                {{ $moment().add(-1, "months").format("YYYYMM") }}
              </div>
              <div class="text-muted text-uppercase font-weight-bold font-xs">
                Last snapshot
              </div>
            </b-card-body>
            <div slot="footer">
              <b-link
                disabled="true"
                class="font-weight-bold font-xs btn-block text-muted"
                href="#"
                >Take snapshot
                <i class="fa fa-angle-right float-right font-lg"></i
              ></b-link>
            </div>
          </b-card>
          <b-tooltip target="cursnapshot" triggers="hover"
            >Last backup snapshot</b-tooltip
          >
        </b-col>
        <b-col cols="12" sm="6" md="4">
          <b-card id="curperiod" :no-body="true">
            <b-card-body class="p-0 clearfix">
              <i
                class="
                  fa fa-calendar-check-o
                  bg-secondary
                  p-4
                  font-2xl
                  mr-3
                  float-left
                "
              ></i>
              <div class="h5 text-primary mb-0 pt-3">
                {{ items[0].CurrentPeriod }}
              </div>
              <div class="text-muted text-uppercase font-weight-bold font-xs">
                Current Period
              </div>
            </b-card-body>
            <div slot="footer">
              <b-link
                disabled="true"
                class="font-weight-bold font-xs btn-block text-muted"
                href="#"
                >Advance Period<i
                  class="fa fa-angle-right float-right font-lg"
                ></i
              ></b-link>
            </div>
          </b-card>
          <b-tooltip target="curperiod" triggers="hover"
            >Current accounting period</b-tooltip
          >
        </b-col>
        <b-col cols="12" sm="6" md="4">
          <b-card id="curyear" :no-body="true">
            <b-card-body class="p-0 clearfix">
              <i
                class="fa fa-calendar bg-secondary p-4 font-2xl mr-3 float-left"
              ></i>
              <div class="h5 text-primary mb-0 pt-3">
                {{ items[0].CurrentYear }}
              </div>
              <div class="text-muted text-uppercase font-weight-bold font-xs">
                Current Year
              </div>
            </b-card-body>
            <div slot="footer">
              <b-link
                disabled="true"
                class="font-weight-bold font-xs btn-block text-muted"
                href="#"
                >Advance Year
                <i class="fa fa-angle-right float-right font-lg"></i
              ></b-link>
            </div>
          </b-card>
          <b-tooltip target="curyear" triggers="hover"
            >Current accounting year</b-tooltip
          >
        </b-col>
      </b-row>

      <b-card class="m-3">
        <b-card-header>Ledger ID Counters</b-card-header>
        <b-card-body class="mb-3">
          <b-list-group horizontal>
            <b-row class="w-100pct">
              <b-col
                class="mb-2"
                cols="12"
                md="6"
                lg="4"
                v-for="(seed, index) in counters"
                :key="index"
              >
                <b-list-group-item class="d-flex align-items-center">
                  <b-avatar
                    square
                    variant="primary"
                    :text="seed.reftype"
                    class="mr-3 w-40px"
                  ></b-avatar>
                  <span class="mr-auto">{{ seed.name }} </span>
                  <b-badge>{{ seed.id.padStart(6, "0") }}</b-badge>
                </b-list-group-item>
              </b-col>
            </b-row>
          </b-list-group>
        </b-card-body>
      </b-card>
      <!-- <b-row class="excelsheetbuttons px-3">
        <b-col>
          <div v-if="busy">
            <i class="fa fa-spinner fa-spin text-primary"></i>
            <span class="small text-primary ml-1">Updating ...</span>
          </div>
          <span v-if="!busy" class="small text-primary"
            >Found {{ items.length }} rows</span
          >
        </b-col>

        <b-col class="text-right">
          <b-link
            id="flights-excel"
            class="mt-1 excel"
            @click="$helpers.outputExcel({ items, fields: options.fields })"
            title="Send to excel"
          >
            <i class="fa fa-file-excel-o" aria-hidden="true"></i>
          </b-link>
          <b-tooltip target="flights-excel" triggers="hover"
            >Grid to excel</b-tooltip
          >
        </b-col>
      </b-row> -->
    </b-card>
  </b-overlay>
</template>


<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import moment from "moment";

export default {
  name: "Periodend",
  props: ["refresh"],
  watch: {
    refresh: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadData();
      },
    },
  },
  data() {
    return {
      addRow: false,
      busy: false,
      find: "",
      items: [],
      counters: [],
      search: {
        selected: null,
      },
      options: {
        title: "Active Period/Counters",
        icon: "fa fa-list-ol",
        debounce: 500,
        fields: [],
        badges: [],
        actions: [],

        actions_as_elipses: false,
        modal: {},
        component: {},
        overlay_show: false,
        overlay: {},
      },
    };
  },
  mounted() {
    // // ONLY ADD ACTIONS IF THE ARRAY EXISTS AND NOT ALREADY ADDED AT CONTROLLED WIDTH
    if (this.options.actions) {
      if (this.options.fields.some((e) => e.key === "actions")) {
      } else {
        this.options.fields.push({
          key: "actions",
          label: "",
          class: "actions w-140px",
        });
      }
    }
    this.$helpers.resizableColumns();

    this.loadData();
  },
  computed: {
    ...mapGetters(["window"]),
  },
  methods: {
    async loadData() {
      this.items = [];

      this.busy = true;

      let variables = {};
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query ledgers {
              ledgers {
                CompanyName
                CurrentPeriod
                CurrentYear
                YearEndMonth
              }
            }
          `,
          variables,
        });
        console.log(response.data.ledgers);

        this.items = response.data.ledgers;
      } catch (error) {
        console.log(error);
      }
      try {
        const response = await this.$apollo.query({
          query: gql`
            query ledgerids {
              ledgerids {
                reftype
                name
                id                
              }
            }
          `,
          variables,
        });
        console.log(response.data.ledgerids);

        this.counters = response.data.ledgerids;
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
      await this.$emit("refreshed");
    },

    async table_action(key, row) {
      this.$root.$emit("bv::hide::popover");
      console.log("you have clicked: ", key, row);

      this.search.selected = row.item;
      for (var i = 0; i < this.options.actions.length; i++) {
        if (this.options.actions[i].key == key) {
          if (this.options.actions[i].hasOwnProperty("modal")) {
            // this.selected = !Array.isArray(sender) ? [sender.item] : sender;
            // this.modal = this.actions[i].modal;
            // this.modalActive = true;
            console.log(this.options.modal);
            return;
          }
          if (this.options.actions[i].hasOwnProperty("component")) {
            this.options.component = this.options.actions[i].component;
            // ONLY ALLOW ONE EXPANSION
            for (var k = 0; k < this.items.length; k++) {
              this.$set(this.items[k], "_showDetails", false);
            }
            row.toggleDetails();
            return;
          }
          if (this.options.actions[i].hasOwnProperty("overlay")) {
            if (this.options.actions[i].overlay.message) {
              let message = this.options.actions[i].overlay.message;
              for (var prop in row.item) {
                if (Object.prototype.hasOwnProperty.call(row.item, prop)) {
                  message = message
                    .split("%" + prop + "%")
                    .join(row.item[prop]);
                }
              }
              this.options.overlay.message = message;
            }
            if (this.options.actions[i].overlay.buttons) {
              this.options.overlay.buttons =
                this.options.actions[i].overlay.buttons;
            }
            this.options.overlay_show = !this.options.overlay_show;
            return;
          }
        }
      }
    },
    async rowClicked(item) {
      console.log("row clicked", item);

      // DEFAULT COMPONENT IS THE FIRST ONE
      if (this.options.actions.length > 0) {
        if (this.options.actions[0].component) {
          this.options.component = this.options.actions[0].component;
        }
      }

      this.search.selected = item;
      let lo = -1;
      // CLOSE ALL
      for (var k = 0; k < this.items.length; k++) {
        if (this.items[k]._showDetails) {
          lo = k;
        }
        this.$set(this.items[k], "_showDetails", false);
      }
      item._showDetails = lo == item.ID ? false : true;
    },
    async discard(row) {
      console.log("discard", row);
      if (row) {
        if (row.item) {
          row.item._showDetails = false;
        }
      }
      this.addRow = false;
    },
    async add() {
      delete this.search.selected;
      this.search.selected = {};
      for (var k = 0; k < this.items.length; k++) {
        this.items[k]._showDetails = false;
      }
      if (this.addRow) {
        this.addRow = false;
        return;
      }
      this.addRow = true;
    },
    async refresh() {
      await this.loadData();
    },
    async outside(e) {
      console.log("clicked outside!");
      this.options.overlay_show = false;
    },
    async dispatcher(action) {
      console.log("dispatcher action", action);
      // let payload = {};
      // await this.$store.dispatch(action, payload);
      this.overlay_show = false;
    },
  },
};
</script>

<style scoped>
.badge {
  font-size: 12px !important;
}
</style>